const styles = {
  homeContent: {
    position: 'relative',
    boxSizing: 'border-box',
    backgroundColor: '#f0f0f0',
    height: { xs: 'calc(100vh - 56px)', sm: 'calc(100vh - 75px)' },
    padding: 2,
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    overflow: 'auto',
  },

  innerCardContainer: {
    flexGrow: 1,
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridTemplateRows: '1fr 1fr',
    gap: 2,
    minHeight: 0,
  },

  headerRow: {
    gridColumn: '1 / -1',
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    alignItems: { xs: 'flex-start', md: 'center' },
    justifyContent: 'space-between',
    gap: 2,
  },

  welcomeMessage: {
    fontFamily: 'Source Sans Pro',
    fontWeight: 600,
    fontSize: { xs: '1.75rem', sm: '2.375rem' },
    lineHeight: '100%',
    color: '#5236AB',
  },
};

export default styles;
